import type { MeetingDepartmentCount } from '@entities/meetings';
import {
  Section,
  SectionLabel,
  FolderGrid,
  FolderCard,
  FolderCardStatic,
  FolderName,
  FolderCount,
} from './styles';

interface DepartmentsSectionProps {
  departments: MeetingDepartmentCount[];
}

export function DepartmentsSection({ departments }: DepartmentsSectionProps) {
  if (departments.length === 0) return null;

  return (
    <Section>
      <SectionLabel>Отделы</SectionLabel>
      <FolderGrid>
        {departments.map((d) =>
          d.department_id ? (
            <FolderCard
              to={`/agents/meetings/department/${d.department_id}`}
              key={d.department_id}
            >
              <FolderName>{d.department_name ?? '—'}</FolderName>
              <FolderCount>{d.count}</FolderCount>
            </FolderCard>
          ) : (
            <FolderCardStatic key="none" title="Совещания без определённого отдела">
              <FolderName>Без отдела</FolderName>
              <FolderCount>{d.count}</FolderCount>
            </FolderCardStatic>
          ),
        )}
      </FolderGrid>
    </Section>
  );
}
